import type { DropdownMultiselectOptionProps } from './types'
import { space, tokPx } from '@sunwebgroup/ui-components'
import { Checkbox, focusWithinOutline, resetFocusOutline, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { DropdownMultiselectContext } from './context'

const Wrapper = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space('primitives_space_8')};
  cursor: pointer;
  min-height: ${tokPx('semantics_controls_m_min_height')};
  border-radius: ${tokPx('semantics_controls_m_corner_radius')};

  ${focusWithinOutline()}

  ${Checkbox} {
    ${resetFocusOutline()}
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`
const Label = styled(Typography)`
    align-self: stretch;
    display: flex;
    flex: 1 1 0%;
    padding: ${space('primitives_space_0')} ${space('primitives_space_8')};
`

interface CheckboxWithExtraProps extends DropdownMultiselectOptionProps {
  description?: string
  count?: number
}

function CheckboxWithExtra({ value, children, count }: CheckboxWithExtraProps) {
  const { selectedValues, removeOption, addOption } = React.useContext(DropdownMultiselectContext)

  const isSelected = selectedValues.includes(value)

  const handleCheckedChange = () => {
    if (isSelected) {
      removeOption(value)
      return
    }

    addOption(value)
  }

  return (
    <Wrapper>
      <Checkbox checked={isSelected} onCheckedChange={handleCheckedChange} />
      <Label>{children}</Label>
      {count && <Typography $variant="body-m-regular-tight">{count}</Typography>}
    </Wrapper>
  )
}

export function CheckboxWithCounterOption(props: CheckboxWithExtraProps) {
  return <CheckboxWithExtra {...props} />
}
